import { error, type NumericRange } from "@sveltejs/kit";
import type { AxiosError } from "axios";
import { isErrorResponse, mapErrorOrElse } from "./mapError";

export async function handleConnectivityErrorInLoader(axiosError: AxiosError) {
  if (!(axiosError.request || axiosError.response)) {
    error(503, { message: "Service unavailable" });
  }
  return Promise.reject(axiosError);
}

export async function handleStatusErrorInLoader(axiosError: AxiosError) {
  if (!axiosError.response) {
    return Promise.reject(axiosError);
  }

  const { statusText, data } = axiosError.response;
  const code = isErrorResponse(data) ? data.code : undefined;

  error(
    axiosError.response.status as NumericRange<400, 599>,
    statusText || code
      ? { message: mapErrorOrElse(code, statusText) }
      : undefined,
  );
}
